import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#005095',  
        },
        secondary: {
            main: '#9f46da',
        },
        test: {
            main: '#47FF3E'
        },
        text: {
            main:'#fff',
            link: '#fff', 
            black: '#000000',
            blue: '#005095'
        },
        error:{
            main: '#c13050'
        }
    },
    components: {
        MuiSelect: {
            variants:
                [
                    {
                        props: { variant: 'filled' },
                        style: {
                            color: 'white',
                            backgroundColor: '#005095',
                            border: 0
                        },
                    },
                ],
        }
    },
  });

